import { SnotifyPosition } from 'vue-snotify'
import 'vue-snotify/styles/material.css'
import snotify from 'vue-snotify'
import { isString } from 'lodash'
import { concatErrorsFromApi } from '@/helpers'


export const snotifyOptions = {
  toast : {
    position        : SnotifyPosition.rightTop,
    showProgressBar : false
  }
}


export const snotifyAction = (type) => 
  function(body, title = null, options = {} ) {
    let message = `<div class="snotifyToast__body">
    ${type === 'error' ? concatErrorsFromApi(body): body}`

    if(isString(title)){
      message = 
      `<div class="snotifyToast__title"><b>${title}</b></div>${message}`
    }

    return this.html(message, { ...options, type  })
  }

export default snotify